/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_QRC_MOVEMENTS_ITEM = {
  id: 'qr_movements',
  screenId: 'fin-qrc-movements',
  label: 'Movimientos',
  description: 'Cobros registrados por QR en el banco.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Consultás los cobros QR que ya quedaron registrados como movimientos bancarios: el importe neto acreditado y la comisión (fee) descontada.',
      },
      {
        title: 'De dónde salen los movimientos',
        paragraphs: [
          'Cada cobro QR se registra al confirmar un recibo en Finanzas → Cobros con medio «Cobro QR», eligiendo la configuración QR.',
          'El sistema genera un ingreso en la cuenta bancaria de esa configuración (monto neto) y, si hay fee configurado, imputa la comisión al costo indicado en la configuración.',
          'Esta pantalla es solo consulta; no imputás ni editás cobros acá.',
        ],
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          {
            label: 'Configuración QR',
            description: 'Terminal o punto de cobro a consultar (solo ves las configuraciones autorizadas para tu usuario).',
          },
          {
            label: 'Fecha desde / Fecha hasta',
            description: 'Período a listar. Por defecto muestra los últimos 7 días hasta hoy.',
          },
        ],
        paragraphs: [
          'Al cambiar configuración o fechas la grilla se actualiza sola.',
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: Fecha, Monto (neto acreditado en banco), Comisión (fee descontado).',
          'Podés paginar y exportar la grilla.',
          'Los mismos movimientos también aparecen en Finanzas → Bancos → Movimientos de la cuenta vinculada.',
        ],
      },
    ],
  },
}
